import { canUseDOM } from '@ps/web-core-utils';
import { isEqual } from 'lodash';
import React, { useRef } from 'react';
import type { SportsEvent, WithContext } from 'schema-dts';

export type StructuredData = SportsEvent;

interface StructuredDataContextValue {
  value?: StructuredData[];
  addStructuredData: (structuredData: StructuredData) => void;
}

export const StructuredDataContext = React.createContext<StructuredDataContextValue>({
  addStructuredData: () => undefined
});

export interface StructuredDataContextType {
  value: StructuredData[];
}

interface Props extends React.PropsWithChildren {
  context?: StructuredDataContextType;
}

const StructuredDataProvider: React.FC<Props> = ({ children, context = { value: [] } }) => {
  const ref = useRef(context);

  const addStructuredData = (structuredData: StructuredData) => {
    if (canUseDOM) {
      return;
    }

    const structuredDataWithContext: WithContext<StructuredData> = {
      '@context': 'https://schema.org',
      ...structuredData
    };

    if (ref.current.value.find((value) => isEqual(structuredDataWithContext, value))) {
      return;
    }

    ref.current.value.push(structuredDataWithContext);
  };

  return (
    <StructuredDataContext.Provider
      value={{
        value: ref.current.value,
        addStructuredData
      }}
    >
      {children}
    </StructuredDataContext.Provider>
  );
};

export default StructuredDataProvider;
